import { ReactNode } from 'react';

import { CtaContent } from 'utils/models';

export enum CarouselVariant {
  SMALL,
  SMALL_FRAME,
  MEDIUM,
  EXTRA_SMALL,
  LARGE,
}

export type CarouselSettings = {
  children: ReactNode[];
  cta?: CtaContent | null;
  titleElement?: ReactNode;
  variant?: CarouselVariant;
};
